module.exports = __webpack_public_path__ + "static/img/v3.c158b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v3.jpg
// module id = +B1W
// module chunks = 1